import Dropdown from '../../Dropdown/Dropdown';
import { useSavedContent } from '../../../hooks/useSavedContent';
import { useDropdownStore } from '../../../stores/dropdownStore';
import styles from './SaveContent.module.less';
import { useTranslation } from 'react-i18next';

const SaveContent = () => {
  const { savedContent, removeSavedContent } = useSavedContent();
  const { isOpen, toggleDropdown } = useDropdownStore();
  const { t } = useTranslation();

  return (
    <>
      {isOpen && (
        <div className={styles['saved-content']}>
          {savedContent.length > 0 ? (
            <div className={styles['saved-content__body']}>
              <Dropdown
                isOpen={isOpen}
                onClose={toggleDropdown}
                items={savedContent}
                groupByCategory={false}
                onItemRemove={removeSavedContent}
                showHeader={false}
              />
            </div>
          ) : (
            <div className={styles['saved-content__empty']}>
             { t("noSavedContent")}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default SaveContent;
